import { memo } from "react";

interface Props {
  highlights: string[];
  title: string;
  bootcampTitle: string;
}

export const BootcampList = memo<Props>(
  ({ highlights, title, bootcampTitle }) => {
    return (
      <div className="bg-white p-10 rounded-[20px]">
        <div className="text-day-base-base-500 uppercase text-[16px] pt-8">
          {bootcampTitle}
        </div>
        <div
          className="pt-6 pb-8 text-[32px] leading-normal"
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        <ul className="list-disc pl-8">
          {highlights.map((item, index) => (
            <li
              key={index}
              className="marker:text-blue pb-12 text-[15px] leading-[130%]"
            >
              <span
                // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: item,
                }}
                className="text-day-base-base-500"
              />
            </li>
          ))}
        </ul>
      </div>
    );
  }
);
